import React from "react";
import {Button, Checkbox, Col, Modal, Row} from "antd";
import {connect} from "react-redux";
import {loadPrivacyPolicy, updatePrivacyPolicy} from "../../actions/account";
import {displayErrors} from "../../libs/utils";
import {Link} from "react-router-dom";

class PrivacyPolicyModal extends React.Component {
    state = {
        loading: true,
        showModal: true,
        privacyPolicy: null,
        agreedTerms: false,
        scrolledToBottom: false,
        saving: false,
    }

    componentDidMount() {
        this.props.loadPrivacyPolicy((res) => {
            this.setState({ loading: false, privacyPolicy: res.data.privacy_policy });
        }, (err) => {
            if(typeof err.response!== 'undefined') {
                displayErrors(err.response.data);
            }
            this.setState({ loading: false });
        })
    }

    agreeToTerms() {
        this.props.updatePrivacyPolicy(() => {
            this.setState({ saving: false });
            window.location.reload();
        }, (err) => {
            if(typeof err.response!== 'undefined') {
                displayErrors(err.response.data);
            }

            this.setState({ saving: false });
        })
    }

    handleScroll = e => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        const reachedBottom = scrollTop + clientHeight >= scrollHeight - 5;

        if (reachedBottom && !this.state.scrolledToBottom) {
            this.setState({ scrolledToBottom: true });
        }
    };

    render() {
        return <Modal
            open={this.state.showModal} title='Updated Privacy Policy' width='700px'
            footer={<Row justify='space-between'>
                <Col>
                    <Link to='/auth/logout'><Button>Log Out</Button></Link>
                </Col>
                <Col>
                    <Button type='primary' onClick={() => this.agreeToTerms()} loading={this.state.saving} disabled={!this.state.agreedTerms || this.state.saving}>Acknowledge and Continue</Button>
                </Col>
            </Row>}
            closable={false} centered>
            <p>We have updated our Privacy Policy to explain how we process personal data. To continue using the Services, please review and acknowledge the updated Privacy Policy. <a href='https://priorityprospect.com/legal/privacy-policy/' target='_blank' rel='noopener noreferrer'><b>View full Privacy Policy in a new tab</b></a>.</p>
            <p>If you do not acknowledge the Privacy Policy, access to the Services will be restricted until the Privacy Policy is reviewed. You may log out or contact our support team if you have questions or wish to request account closure.</p>
            <div style={{height: '400px', overflowX: 'auto', border: '1px solid #ccc', padding: '10px'}}
                 dangerouslySetInnerHTML={{__html: this.state.privacyPolicy}} onScroll={this.handleScroll} />
            <div>
                <Checkbox disabled={!this.state.scrolledToBottom} onChange={(e) => this.setState({ agreedTerms: e.target.checked }) }>
                    I acknowledge that I have read and understood the Privacy Policy.
                </Checkbox>
            </div>

        </Modal>;
    }
}

export default connect(null, { loadPrivacyPolicy, updatePrivacyPolicy })(PrivacyPolicyModal);